// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mMrs","question":"styles_question__1BrFE","description":"styles_description__1kN8C"};